import { APP_COLORS } from '@/config/colors';

// Mapa konwersji klas Tailwind na kolory hex z APP_COLORS
const COLOR_MAP: Record<string, string> = {
  // Gray colors
  'gray-100': APP_COLORS.gray[100],
  'gray-200': APP_COLORS.gray[200],
  'gray-300': APP_COLORS.gray[300],
  'gray-400': APP_COLORS.gray[400],
  'gray-500': APP_COLORS.gray[500],
  'gray-600': APP_COLORS.gray[600],
  'gray-700': APP_COLORS.gray[700],
  'gray-800': APP_COLORS.gray[800],

  // Green colors
  'green-200': APP_COLORS.green[200],
  'green-400': APP_COLORS.green[400],
  'green-500': APP_COLORS.green[500],
  'green-600': APP_COLORS.green[600],
  'green-700': APP_COLORS.green[700],
  'green-800': APP_COLORS.green[800],

  // Red colors
  'red-200': APP_COLORS.red[200],
  'red-400': APP_COLORS.red[400],
  'red-600': APP_COLORS.red[600],
  'red-800': APP_COLORS.red[800],

  // Other colors
  yellow: APP_COLORS.yellow,
  yellowDark: APP_COLORS.yellowDark,
  orange: APP_COLORS.orange,
  orangeBright: APP_COLORS.orangeBright,
  blue: APP_COLORS.blue.DEFAULT,

  // Primary colors
  'primary-50': APP_COLORS.primary[50],
  'primary-100': APP_COLORS.primary[100],
  'primary-200': APP_COLORS.primary[200],
  'primary-300': APP_COLORS.primary[300],
  'primary-400': APP_COLORS.primary[400],
  'primary-500': APP_COLORS.primary[500],
  'primary-600': APP_COLORS.primary[600],
  'primary-700': APP_COLORS.primary[700],

  // Zinc colors
  'zinc-800': APP_COLORS.zinc[800],
} as const;

// Funkcja do konwersji klasy Tailwind na kolor hex
export const getTailwindColorHex = (tailwindClass: string): string => {
  // Wyciąga nazwę koloru z klasy (np. 'bg-green-700' -> 'green-700')
  const colorKey = tailwindClass.replace(/^(bg-|text-|border-)/, '');
  return COLOR_MAP[colorKey] || '#000000'; // fallback na czarny
};
